import React, { useState } from 'react';
import Form, { FormComponentProps } from 'antd/lib/form';
import { FormValuesSap } from '../../../../../core-module/selectors/Order/types';
import {
  BezorgmomentResponse,
  CustomerInformationForBezorgmomentenResponse
} from '../../../../../core-module/services/deliverer/types';
import { OrderFormComponent } from './OrderFormComponent';

interface OwnProps {
  readonly customerInformation: CustomerInformationForBezorgmomentenResponse;
  readonly customerDefaultPortionSize: string | null;
  readonly onHideClick: () => void;
  readonly hasValidPaymentMethod: boolean;
}

type Props = OwnProps & FormComponentProps<FormValuesSap>;

const OrderFormContainer: React.FC<Props> = ({
  customerInformation,
  customerDefaultPortionSize,
  onHideClick,
  hasValidPaymentMethod,
  form
}) => {
  const [isSubmitting] = useState(false);
  const [selectedBezorgmoment, setSelectedBezorgmoment] = useState<BezorgmomentResponse | null>();

  return (
    <OrderFormComponent
      form={form}
      customerInformation={customerInformation}
      isSubmitting={isSubmitting}
      customerDefaultPortionSize={customerDefaultPortionSize}
      selectedBezorgmoment={selectedBezorgmoment || null}
      setSelectedBezorgmoment={setSelectedBezorgmoment}
      onHideClick={onHideClick}
      hasValidPaymentMethod={hasValidPaymentMethod}
    />
  );
};
export default Form.create<Props>()(OrderFormContainer);
